import React, {FC, useEffect, useState} from 'react'
import {PropsProducts} from '../products/TypesProducts'
import GetProducts from '../../modules/functions/get/GetProducts'
import {CreateProduct} from '../../modules/all-pages'

const CreateAccountWP: FC = () => {

    const [productsData, setProductsData] = useState<PropsProducts[]>([]);
    const account = "ClientReports"

    useEffect(() => {

        GetProducts({setProductsData});
    }, []);

    return (
        <>
            {
                productsData.map((product, index) =>
                  (product.name === account)
                    ? (
                      <CreateProduct name={product.name}
                                     description={product.description}
                                     treaty={product.treaty}
                                     key={index}
                      />
                    ) : ""
                )
            }
        </>
    )
}
export {CreateAccountWP}
